import { useEffect, useRef, useState } from 'react';
import './index.scss';
import clsx from 'clsx';
import {
  LANGUAGE_OPTIONS,
  TOption,
} from './helpers/constants';
import {
  getLanguage,
  getLanguageLabel,
} from './helpers/functions';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import {
  CUSTOM_EVENTS,
  appLogEvent,
} from '../../utils/analytics';
import { encrypted } from '../../utils/utility';

interface LanguageProps {
  onChange: (newValue: string) => void;
}
export function LanguageSelect({ onChange }: LanguageProps) {
  const [open, setOpen] = useState(false);
  const selectRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const encryptedLang = localStorage.getItem('lang');
    let storedLanguage = 'en';

    if (encryptedLang) {
      try {
        storedLanguage = encrypted.decrypt(encryptedLang);
      } catch (err) {
        console.error('Failed to decrypt language:', err);
      }
    }

    onChange(storedLanguage);
  }, []);

  const handleOptionSelection = (option: TOption) => {
    const encryptedLang = encrypted.encrypt(option.value);
    localStorage.setItem('lang', encryptedLang);

    onChange(option.value);
    setOpen(false);
    appLogEvent(CUSTOM_EVENTS.LANG_CHANGED, {
      language: getLanguage(),
    });
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      selectRef.current &&
      !selectRef.current.contains(event.target as Node)
    ) {
      setOpen(false);
    }
  };

  useEffect(() => {
    open &&
      document.addEventListener(
        'click',
        handleClickOutside
      );
    return () => {
      document.removeEventListener(
        'click',
        handleClickOutside
      );
    };
  }, [open]);

  const selectedLanguage = getLanguage();

  return (
    <div className="lang-select" ref={selectRef}>
      <button
        onClick={() => setOpen(!open)}
        className="select_btn">
        <span>{getLanguageLabel(selectedLanguage)}</span>
        <ExpandLessIcon
          className={open ? '' : 'rotate-180'}
        />
      </button>
      {open && (
        <div className="options-overlay">
          <div className="options-wrapper">
            {LANGUAGE_OPTIONS.map((option) => (
              <div
                onClick={() =>
                  handleOptionSelection(option)
                }
                key={option.value}
                className={clsx(
                  'option',
                  option.value === selectedLanguage
                    ? 'option--selected'
                    : ''
                )}>
                {option.label}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
